var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleCancel,
          expression: "handleCancel"
        }
      ],
      class: _vm.classes,
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.toggleEditMode($event)
        }
      }
    },
    [
      !_vm.editMode
        ? [
            _vm.loading
              ? _c("CompassSkeleton", {
                  style: { width: _vm.componentWidth + "px" },
                  attrs: { size: "x-large" }
                })
              : [
                  _vm.placeholder && !_vm.text
                    ? _c(
                        "div",
                        {
                          ref: "editTextPlaceholder",
                          staticClass:
                            "edit-text__placeholder typographies-paragraph-medium-regular"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.placeholder) +
                              "\n            "
                          )
                        ]
                      )
                    : _c(
                        "div",
                        {
                          ref: "editTextValue",
                          staticClass: "edit-text__value"
                        },
                        [_vm._t("default")],
                        2
                      )
                ]
          ]
        : [
            _c("CompassInput", {
              ref: "editTextInput",
              class: _vm.contentTypographyClass,
              style: { maxWidth: _vm.componentWidth + "px" },
              on: { keypress: _vm.handleKeyPress },
              nativeOn: {
                keypress: function($event) {
                  return _vm.limitTextLength($event)
                },
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.handleValueUpdate($event)
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape"
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.handleCancel($event)
                  }
                ]
              },
              scopedSlots: _vm._u(
                [
                  _vm.prefix
                    ? {
                        key: "prefix",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.numberFormat.currencysymbol) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    : null,
                  _vm.suffix
                    ? {
                        key: "suffix",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.numberFormat.currencysymbol) +
                                "\n            "
                            )
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              ),
              model: {
                value: _vm.localValue,
                callback: function($$v) {
                  _vm.localValue = $$v
                },
                expression: "localValue"
              }
            }),
            _vm._v(" "),
            _c("FloatingActions", {
              attrs: { float: _vm.floatActions },
              on: { cancel: _vm.handleCancel, save: _vm.handleValueUpdate }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }